var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"container-fluid pb-0"},[_vm._v(" "+_vm._s(_vm.$auth.check())+" "+_vm._s(_vm.$auth.user())+" "),_c('AccountStats'),_c('hr'),_c('AccountVideos'),_c('hr',{staticClass:"mt-0"}),_c('AccountChannels')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }